// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-videos {
    margin-top: 20px;
}

.custom-container {
    padding-left: 8%;
    padding-right: 8%;
}

.custom-container h5 {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
}

.custom-container h5.top-heading {
    font-size: 28px;
    margin-bottom: 20px;
}

.view-all {
    color: #6655ee !important;
    margin-left: 15px;
    font-weight: 300;
}

.drafts {
    font-weight: 600;
    color: #000 !important;
}

.custom-container p {
    color: #a6a3a3;
    font-size: 12px;
    margin-bottom: 10px;
}

.like-cmt-select > select {
    height: 50px;
    font-size: 15px;
    border: none !important;
    border-bottom: 1px solid #dbdbdb !important;
    border-radius: 0;
}

.like-cmt-select > span {
    position: absolute;
    font-size: 15px;
    left: 30px;
    top: 15px;
    color: #878787;
}

.like-cmt-select button span {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #555;
    display: inline-block;
}

.like-cmt-select button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    top: 25px;
    width: 50px;
    background-color: #f5f7f6;
}

.video-container {
    margin-bottom: 15px;
    padding: 10px;
}

.aal-cat {
    display: inline-block;
    padding: 5px 16px;
    margin-right: 5px;
    border-radius: 12px;
    margin-bottom: 5px;
}

.aal-cat:hover {
    background-color: #FFF;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
}


.infor {
    font-size: 14px;
    margin: 10px 0px;
}

.infor img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 5px;
}

.infor .profile-image {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    font-size: 14px;
    margin: 0;
    margin-right: 5px;
}

.infor .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
}

.video-container:hover {
    background-color: #FFF;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);

}

.video-container:hover .published-options {
    display: block;
}

.video-container:hover .published-views {
    display: none;
}

.published-options li {
    padding: 5px 10px;
}

.published-options {
    display: none;
    list-style-type: none;
}

.published-options li a:hover {
    color: #6e5eff;
}

.published-views {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.over {
    position: absolute;
    top: 0;
    font-size: 14px;
    color: #fff;
    right: 15px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
}

.over span {
    display: inline-block;
    margin: 5px;
    font-size: 12px;
}

.published-views li {
    display: inline-block;
    margin-right: 15px;
}

.draft-row {
    margin-bottom: 70px;
}

h5 {
    margin-top: 15px;
}

.poster {
    width: 100%;
    height: 160px;
    object-fit: cover;
    cursor: pointer;
}

h6 {
    margin-top: 10px;
    /* margin-left: 10px; */
    font-weight: 600
}

.hove-one {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    opacity: 0;
    height: 100%;
    width: 100%;
    text-align: center;
    z-index: -1;
    align-items: center;
    display: flex;
    background: rgba(0, 0, 0, 0.5);

}

.hove-one a {
    display: inline-block;
    padding: 10px;
    width: 32%;
    color: #fff;
}

.hove-one a svg {
    font-size: 20px;
}

.hove-one a:hover {
    color: #6655ee;
}

.class-hover {
    position: relative;
}

.class-hover:hover .hove-one {
    opacity: 1;
    z-index: 9
}

.contributor {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
}

.contributor-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.contributor-list li {
    margin-bottom: 20px;
}

.contributor-modal {
    width: 25px;
    height: 25px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
}

.icon:hover {
    fill: #6655ee;
}

.view-contributors {
    cursor: pointer;
    color: #6655ee !important;
}

.videoSection{
    height: 750px;
    overflow-y: scroll;
    overflow-x: hidden;
}


::ng-deep .mat-tooltip{
    max-width: -moz-fit-content !important;
    max-width: fit-content !important;
    padding-block: 14px;
    font-size : 15px !important;
}


@media (max-width: 991px) {
    .published-views {
        margin-bottom: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/beforeLogin/categoryWiseVideo/categoryWiseVideo.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,8CAA8C;AAClD;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,8CAA8C;;AAElD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,8BAA8B;;AAElC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,sCAAiC;IAAjC,iCAAiC;IACjC,mBAAmB;IACnB,2BAA2B;AAC/B;;;AAGA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".my-videos {\r\n    margin-top: 20px;\r\n}\r\n\r\n.custom-container {\r\n    padding-left: 8%;\r\n    padding-right: 8%;\r\n}\r\n\r\n.custom-container h5 {\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.custom-container h5.top-heading {\r\n    font-size: 28px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.view-all {\r\n    color: #6655ee !important;\r\n    margin-left: 15px;\r\n    font-weight: 300;\r\n}\r\n\r\n.drafts {\r\n    font-weight: 600;\r\n    color: #000 !important;\r\n}\r\n\r\n.custom-container p {\r\n    color: #a6a3a3;\r\n    font-size: 12px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.like-cmt-select > select {\r\n    height: 50px;\r\n    font-size: 15px;\r\n    border: none !important;\r\n    border-bottom: 1px solid #dbdbdb !important;\r\n    border-radius: 0;\r\n}\r\n\r\n.like-cmt-select > span {\r\n    position: absolute;\r\n    font-size: 15px;\r\n    left: 30px;\r\n    top: 15px;\r\n    color: #878787;\r\n}\r\n\r\n.like-cmt-select button span {\r\n    border-left: 5px solid transparent;\r\n    border-right: 5px solid transparent;\r\n    border-top: 6px solid #555;\r\n    display: inline-block;\r\n}\r\n\r\n.like-cmt-select button {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 16px;\r\n    top: 25px;\r\n    width: 50px;\r\n    background-color: #f5f7f6;\r\n}\r\n\r\n.video-container {\r\n    margin-bottom: 15px;\r\n    padding: 10px;\r\n}\r\n\r\n.aal-cat {\r\n    display: inline-block;\r\n    padding: 5px 16px;\r\n    margin-right: 5px;\r\n    border-radius: 12px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.aal-cat:hover {\r\n    background-color: #FFF;\r\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n\r\n.infor {\r\n    font-size: 14px;\r\n    margin: 10px 0px;\r\n}\r\n\r\n.infor img {\r\n    width: 40px;\r\n    height: 40px;\r\n    object-fit: cover;\r\n    border-radius: 4px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.infor .profile-image {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    margin: 0;\r\n    margin-right: 5px;\r\n}\r\n\r\n.infor .title {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.video-container:hover {\r\n    background-color: #FFF;\r\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);\r\n\r\n}\r\n\r\n.video-container:hover .published-options {\r\n    display: block;\r\n}\r\n\r\n.video-container:hover .published-views {\r\n    display: none;\r\n}\r\n\r\n.published-options li {\r\n    padding: 5px 10px;\r\n}\r\n\r\n.published-options {\r\n    display: none;\r\n    list-style-type: none;\r\n}\r\n\r\n.published-options li a:hover {\r\n    color: #6e5eff;\r\n}\r\n\r\n.published-views {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.over {\r\n    position: absolute;\r\n    top: 0;\r\n    font-size: 14px;\r\n    color: #fff;\r\n    right: 15px;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    border-radius: 4px;\r\n}\r\n\r\n.over span {\r\n    display: inline-block;\r\n    margin: 5px;\r\n    font-size: 12px;\r\n}\r\n\r\n.published-views li {\r\n    display: inline-block;\r\n    margin-right: 15px;\r\n}\r\n\r\n.draft-row {\r\n    margin-bottom: 70px;\r\n}\r\n\r\nh5 {\r\n    margin-top: 15px;\r\n}\r\n\r\n.poster {\r\n    width: 100%;\r\n    height: 160px;\r\n    object-fit: cover;\r\n    cursor: pointer;\r\n}\r\n\r\nh6 {\r\n    margin-top: 10px;\r\n    /* margin-left: 10px; */\r\n    font-weight: 600\r\n}\r\n\r\n.hove-one {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    opacity: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    text-align: center;\r\n    z-index: -1;\r\n    align-items: center;\r\n    display: flex;\r\n    background: rgba(0, 0, 0, 0.5);\r\n\r\n}\r\n\r\n.hove-one a {\r\n    display: inline-block;\r\n    padding: 10px;\r\n    width: 32%;\r\n    color: #fff;\r\n}\r\n\r\n.hove-one a svg {\r\n    font-size: 20px;\r\n}\r\n\r\n.hove-one a:hover {\r\n    color: #6655ee;\r\n}\r\n\r\n.class-hover {\r\n    position: relative;\r\n}\r\n\r\n.class-hover:hover .hove-one {\r\n    opacity: 1;\r\n    z-index: 9\r\n}\r\n\r\n.contributor {\r\n    width: 30px;\r\n    height: 30px;\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n}\r\n\r\n.contributor-list {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.contributor-list li {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.contributor-modal {\r\n    width: 25px;\r\n    height: 25px;\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n    margin-right: 10px;\r\n}\r\n\r\n.icon:hover {\r\n    fill: #6655ee;\r\n}\r\n\r\n.view-contributors {\r\n    cursor: pointer;\r\n    color: #6655ee !important;\r\n}\r\n\r\n.videoSection{\r\n    height: 750px;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n}\r\n\r\n\r\n::ng-deep .mat-tooltip{\r\n    max-width: fit-content !important;\r\n    padding-block: 14px;\r\n    font-size : 15px !important;\r\n}\r\n\r\n\r\n@media (max-width: 991px) {\r\n    .published-views {\r\n        margin-bottom: 30px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
